module.exports = __webpack_public_path__ + "media/images/logo_300dpi_cmyk-b0679a37.jpg";